import {getFieldsByPath} from "../liberality/utils"
import {setDataList, setFieldVisibility} from "../../../../apps/KpModule/actions"
import {getDataListList} from "../../../../apps/KpModule/selectors"
import {activityNames, hasOtherActivity, newOrganizationActivities, OTHER_ACTIVITY_ID} from "../staticEntities"

const otherActivityOption = newOrganizationActivities.find(activity => activity.id === OTHER_ACTIVITY_ID)

// Form field typed when "Autre" is among the activities, shown right after them.
export const otherActivityFormField = props => ({
    path: 'otherActivity',
    tKey: 'otherActivity',
    placeholder: "Préciser l'activité",
    ...props
})

// Shows the "Autre" precision only when "Autre" is selected in `activitiesPath`.
// The value itself is cleared on save (see clearOtherActivity), not here, so that
// it isn't lost while the form is loading.
export function refreshOtherActivityField({store, module}, activitiesPath, enabled = true) {
    const fields = getFieldsByPath(module.viewMap.form.fields, [activitiesPath, 'otherActivity'])
    if (!fields.otherActivity) return
    const visible = enabled && hasOtherActivity(fields[activitiesPath]?.getValue())
    store.dispatch(setFieldVisibility(fields.otherActivity.id, visible))
}

export function clearOtherActivity(object, activitiesPath) {
    // activities not part of the saved fieldPath: nothing to check
    if (!Array.isArray(object[activitiesPath])) return
    if (!hasOtherActivity(object[activitiesPath])) object.otherActivity = ''
}

// Renames the "Autre" option of a loaded activity list into "Autre (precision)",
// so the establishments' activity tags show the association's precision.
export function relabelOtherActivityOption(store, listId, otherActivity) {
    let options
    try {
        options = getDataListList(store.getState(), listId)
    } catch (error) {
        return
    }
    if (!options?.some(option => option.id === OTHER_ACTIVITY_ID)) return
    store.dispatch(setDataList(listId, options.map(option => option.id === OTHER_ACTIVITY_ID
        ? {...option, name: activityNames([otherActivityOption], otherActivity)[0]}
        : option
    )))
}
